import CES2026 from '@elem/compPage/CES2026';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { redirectTo404 } from '@/utils/redirect404';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';
import { sites } from '@elem/compPage/CES2026/config/page';
import { ProductProvider } from '@elem/compPage/CES2026/ProductProvider';
import { initalState } from '@elem/compPage/CES2026/context/initialState';

export default function Page({ SEO, pageStatus }: any) {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('ces2026');

    return (
        <PageLayout isNoFixed={true} theme={'black'}>
            <SEO title={t('seo_title')} description={t('seo_desc')} keywords={t('seo_keywords')} />
            <SEOlinksA locale={locale} list={sites} pathname={'ces-2026'} />
            <ProductProvider children={<CES2026 />} pageStatus={pageStatus} />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale = 'us', query }: GetServerSidePropsContext) {
    if (!sites.includes(locale)) {
        return redirectTo404();
    }
    const _timer = query?._timer ? String(query?._timer) : undefined;
    const props = initalState(locale, _timer);
    if (props === '404') {
        return redirectTo404();
    }
    return {
        props,
    };
}
